module.exports = __webpack_public_path__ + "h5/img/Tylor.988fe3a7.jpg";